import React from 'react';
import {
    FooterContent,
    FooterLeft,
    FooterWrapper,
    LanguageSelectorWrapper,
    StyledLanguageSelectorSkeleton,
    StyledSkeleton,
} from './Footer.style';

export const FooterSkeleton = React.memo(() => {
    return (
        <FooterWrapper className="ti-footer-wrapper" disabled>
            <FooterContent>
                <FooterLeft>
                    <StyledSkeleton variant={'rounded'} height="14px" width="200px" />
                    {Array.from({ length: 8 }, (_s, i) => (
                        <StyledSkeleton key={i} variant={'rounded'} height="14px" width="100px" />
                    ))}
                </FooterLeft>
                <LanguageSelectorWrapper>
                    <StyledLanguageSelectorSkeleton variant={'rounded'} height="28px" width="170px" />
                </LanguageSelectorWrapper>
            </FooterContent>
        </FooterWrapper>
    );
});
